import type { Table } from 'dexie';
import type { Tournament } from '@/api/models';
import db, { Database } from '@/db';

export type TABLE_TYPE = Table<Tournament, number>;
export const TABLE = 'tournament';
const SCHEMA = 'tournamentId, sortId';

export class TournamentDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  async bulkAdd(payload: Tournament[]): Promise<Tournament[]> {
    await this.db.transaction('rw', this.db[TABLE], async () => {
      await this.db[TABLE].clear();
      await this.db[TABLE].bulkPut(payload);
    });
    return payload;
  }

  list(): Promise<Tournament[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const TournamentDB = new TournamentDatabase(db);
